import { useQueryClient } from "@tanstack/react-query";

import { auditRolesKeys } from "./query_keys";

export const useAuditRolesInvalidate = () => {
  const cache = useQueryClient();
  return {
    invalidateAll: () => cache.invalidateQueries({ queryKey: auditRolesKeys.all() })
  };
};
